import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProgressBarModule } from 'primeng/progressbar';

/**
 * IMPORTANT: its parent must have class="relative"
 */
@Component({
  selector: 'app-overlay-progress',
  standalone: true,
  template: `
    <div
      class="w-full h-full flex z-5 justify-content-center align-items-center"
      [class.absolute]="hasAbsolutePosition"
      style="background: rgba(255, 255, 255, 0.7)"
    >
      <div class="w-6">
        @if (message) {
          <p class="text-color-secondary">{{ message }}</p>
        }
        <p-progressBar [value]="progress"></p-progressBar>
      </div>
    </div>
  `,
  imports: [ProgressBarModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppOverlayProgressComponent {
  @Input() progress: number = 0;
  @Input() message: string = '';
  @Input() hasAbsolutePosition: boolean = true;
}
